//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { number_chinese } from '@/utils/index';
import { reportList } from '@/api/PMS/chargeManagement/rushFeeList/rushFeeList';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      listData: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    handCancle: function handCancle() {
      this.$emit('handCancle', true);
    },
    numberChinese: function numberChinese(data) {
      return number_chinese(data);
    },
    init: function init() {
      var _this = this;

      reportList(this.keyValue).then(function (r) {
        _this.listData = r.data.data;
      });
    },
    // 打印
    print: function print() {
      this.$print(this.$refs.print);
    }
  }
};